import { frontendURL } from 'dashboard/helper/URLHelper';

const PhysiciansIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/physicians'),
      name: 'settings_physicians',
      component: PhysiciansIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
